// Fichier : BlogAutoSurf.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoBanner from "../../assets/images/new_logo_without_font.png";
import HighPerformanceAd from "../../components/HighPerformanceAd";
import autosurfImage from "../../assets/images/autosurf_preview.png";

export default function BlogAutoSurf() {
  useEffect(() => {
    document.title = "Blogs - Get free BTC with the Autosurf | CoinzUp";
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-x-hidden">
      <header className="border-b border-gray-800 px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/index">
          <img src={logoBanner} alt="CoinZUp Logo" className="w-32 sm:w-40 h-auto" />
        </Link>
        <div className="space-x-3 sm:space-x-4 text-sm sm:text-base">
          <Link to="/blog" className="hover:underline">Blog</Link>
          <Link to="/login" className="hover:underline">Log In</Link>
          <Link to="/register" className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition">Sign Up</Link>
        </div>
      </header>

          {/* 🄸🄵🅁🄰🄼🄴 🔽 always visible and responsive */}
    <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90}/>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-yellow-400 mb-6">
           Earn Coinz Effortlessly with AutoSurf
        </h1>

        <div className="mb-8">
          <img 
            src={autosurfImage} 
            alt="AutoSurf dashboard interface showing earnings in real-time" 
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        <p className="text-gray-300 mb-4 text-lg">
          What if you could earn money just by staying connected? With CoinzUp's <strong className="text-yellow-300">AutoSurf</strong>, that’s no longer a dream — it’s a daily reality.
        </p>

        <h2 className="text-2xl font-semibold text-green-400 mb-4 mt-8">
           What is AutoSurf?
        </h2>
        <p className="text-gray-400 mb-4">
          AutoSurf is a passive earning system where you automatically visit advertiser websites. Each site viewed earns you <strong className="text-green-300">0.5 Coinz</strong> — and the more time you stay active, the more it adds up.
        </p>
        <p className="text-gray-400 mb-4">
          Your earnings increase with your <Link to="/levelup" className="text-yellow-300 underline">level</Link>, so consistency pays off.
        </p>

        <h2 className="text-2xl font-semibold text-blue-400 mb-4 mt-8">
           A Smart Way to Stack Coinz While You Chill
        </h2>
        <ul className="list-disc list-inside text-gray-300 mb-6">
          <li> Stay connected and let the AutoSurf run</li>
          <li> Your browser does the work — you just watch your Coinz grow</li>
          <li> The more you surf, the faster you level up — and boost your earnings</li>
        </ul>
        <p className="text-gray-300 mb-4">
          Whether you’re working, gaming, or just browsing — leave CoinzUp open and collect rewards passively.
        </p>

        <h2 className="text-2xl font-semibold text-yellow-400 mb-4 mt-8">
           For Advertisers: Get Real Traffic & Earn XP
        </h2>
        <p className="text-gray-400 mb-4">
          Promoting your website or offer? CoinzUp gives you a powerful traffic tool. By purchasing ads via <Link to="/buyads" className="text-yellow-300 underline">/buyads</Link>, your site will be seen by thousands of active AutoSurf users.
        </p>
        <p className="text-gray-400 mb-4">
          Each ad purchase grants you <strong className="text-green-300">extra XP</strong> — which can unlock bonuses, levels, and more.
        </p>
        <ul className="list-disc list-inside text-gray-300 mb-6">
          <li> Real human traffic — no bots</li>
          <li> Boost your visibility and brand</li>
          <li> Level up faster with bonus XP</li>
        </ul>

        <h2 className="text-2xl font-semibold text-pink-400 mb-4 mt-8">
          👥 Invite Friends & Earn Even More
        </h2>
        <p className="text-gray-400 mb-4">
          With our referral system, you earn <strong className="text-yellow-300">5%</strong> of everything your referrals earn — forever. That includes every Coinz they make through AutoSurf, hourly draws, or trades.
        </p>
        <p className="text-gray-300 mb-4">
          The bigger your network, the faster your earnings grow — passively.
        </p>

        <h2 className="text-2xl font-semibold text-green-400 mb-4 mt-8">
           Get Started in Seconds
        </h2>
        <ul className="list-disc list-inside text-gray-300 mb-6">
          <li> Log in or create your free account</li>
          <li> Go to the AutoSurf section</li>
          <li> Start earning — automatically!</li>
        </ul>

        <p className="text-gray-300 font-semibold mt-6 mb-4">
          Let your browser make money for you. Stay online, earn Coinz, and build your wealth — one surf at a time.
        </p>

        <p className="text-gray-500 text-sm italic">
          Article published on May 17, 2025 — By CoinzUp
        </p>
      </div>
      <HighPerformanceAd keyId="96e99453a24be0353f2fe26dc0b9b728" width={468} height={60}/>
    </div>
  );
}
